import styles from './products-preview.module.scss';
import PreviewWrapper from '@components/shared/header/nav-previews/preview-wrapper/preview-wrapper';
import Link from 'next/link';
import { Themes } from '@layouts/main-layout/themes.enum';
import { ReactSVG } from 'react-svg';
import { ProductsPreviewState } from '../../../nav-state/products-preview.state';
import { Dispatch, SetStateAction } from 'react';
import React from 'react';
import { useTranslations } from 'next-intl';

type ProductsPreviewProps = {
  theme: Themes;
};

const ProductsPreview = ({ theme }: ProductsPreviewProps) => {
  const { columns } = ProductsPreviewState;
  const t = useTranslations();

  const themedClasses = (classes: string) => `${classes} ${styles[theme]}`;
  const arrowIconSrc = '/layout-images/header/icons/chevron-right.svg';

  return (
    <PreviewWrapper theme={theme}>
      <div className={themedClasses(styles.cards)}>
        {columns.map((column, columnIndex) => (
          <div key={columnIndex} className={styles.column}>
            {column.cards.map((card, cardIndex, array) => (
              <React.Fragment key={cardIndex}>
                <div className={styles.cards__default}>
                  <Link scroll={false} href={card.href} passHref legacyBehavior>
                    <div className={styles.cards__wr}>
                      <ReactSVG
                        style={{ maxWidth: '32px', maxHeight: '32px' }}
                        src={card.iconSrc}
                      />
                      <div className={styles.cards__title__wr}>
                        <h4 className={styles.cards__title}>{t(card.title)}</h4>
                        <div className={styles.cards__subtitle}>{t(card.subtitle)}</div>
                      </div>
                      <ReactSVG
                        style={{ maxWidth: '16px', maxHeight: '16px' }}
                        src={arrowIconSrc}
                      />
                    </div>
                  </Link>
                </div>
                {cardIndex !== array.length - 1 && <hr className={styles.divider} />}
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
    </PreviewWrapper>
  );
};

export default ProductsPreview;
